import { STRINGS } from '../i18n';
import type { Category, Lang } from '../types';

/** id, icon — the translations come from the bundled STRINGS below. */
const SEED: [string, string][] = [
  ['special', 'cat-special'],
  ['pavbhaji', 'cat-pavbhaji'],
  ['pulao', 'cat-pulao'],
  ['dosa', 'cat-dosa'],
  ['rollcut', 'cat-rollcut'],
  ['premroll', 'cat-premroll'],
  ['soup', 'cat-soup'],
  ['manchurian', 'cat-manchurian'],
  ['rice', 'cat-rice'],
  ['noodles', 'cat-noodles'],
  ['bhel', 'cat-bhel'],
  ['chinese', 'cat-chinese'],
  ['drinks', 'cat-drinks'],
];

/**
 * The menu that ships inside the app. It is only a fallback: the live menu is
 * loaded from the database and cached on the device. This keeps a brand-new
 * install usable before its first sync, and keeps the till working if the
 * cache is ever wiped while offline.
 */
export const FALLBACK_CATEGORIES: Category[] = SEED.map(([id, icon], i) => ({
  id,
  name: STRINGS.en[('cat_' + id) as keyof typeof STRINGS.en] ?? id,
  nameHi: STRINGS.hi[('cat_' + id) as keyof typeof STRINGS.hi] ?? '',
  nameGu: STRINGS.gu[('cat_' + id) as keyof typeof STRINGS.gu] ?? '',
  icon,
  sortOrder: i * 10,
  active: true,
}));

/** Name in the requested language, falling back to English. */
export function categoryName(cat: Category | undefined, lang: Lang): string {
  if (!cat) return '';
  if (lang === 'hi' && cat.nameHi) return cat.nameHi;
  if (lang === 'gu' && cat.nameGu) return cat.nameGu;
  return cat.name;
}

export function sortCategories(list: Category[]): Category[] {
  return [...list].sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name));
}
